import { useEffect, useState } from "react";
import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay"
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal"
import { useModal } from "../../contexts/ModalContext"
import axios from "axios";
import SmallLoading from "../../Componentes/Utils/SmallLoading";
import { useToast } from "../../contexts/ToastContext";

const ModalRepEdit = ({ id, fetchSuccess }) => {

    const { closeModal } = useModal();
    const { notifyError, notifySuccess } = useToast();

    const [loading, setLoading] = useState(true);

    const [formValues, setFormValues] = useState({
        situacao: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        estado: '',
        cidade: '',
        centroCusto: '',
        republica: '',
        inicioContrato: '',
        fimContrato: '',
        valorAluguel: ''
    })

    const [centrosCustoOptions, setCentrosCustoOptions] = useState([])

    useEffect(() => {

        const fetchData = async () => {
            setLoading(true);
            try {
                const promises = [
                    axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/GetObrasAtivas/'),
                ]
                if (id) { promises.push(axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Republicas/GetRepById/index.php?id=${id}`)) }

                const [centrosCustoRes, repRes] = await Promise.all(promises);

                setCentrosCustoOptions(centrosCustoRes.data.map(item => item.OBRA))
                if (repRes) {
                    const data = repRes.data;
                    setFormValues({
                        situacao: data.situacao,
                        logradouro: data.logradouro,
                        numero: data.numero,
                        complemento: data.complemento || '',
                        bairro: data.bairro,
                        estado: data.estado,
                        cidade: data.cidade,
                        centroCusto: data.centro_custo,
                        republica: data.nome_rep,
                        inicioContrato: data.inicio_contrato || '',
                        fimContrato: data.termino_contrato || '',
                        valorAluguel: data.valor_aluguel
                    });
                }

            } catch (e) {
                console.error(e)
            } finally {
                setLoading(false);
            }
        }

        fetchData();

    }, [id]);

    const listaEstados = [
        "AC", "AL", "AP", "AM", "BA", "CE", "ES", "GO", "MA", "MT",
        "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS",
        "RO", "RR", "SC", "SP", "SE", "TO"
    ];
    const [municipios, setMunicipios] = useState([]);

    useEffect(() => {

        const fetchMunicipios = async (estado) => {

            try {
                const { data } = await axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estado}/municipios`);
                setMunicipios(data.map((item) => (
                    item.nome.toUpperCase()
                )));
            } catch (e) {
                console.error(e)
            }

        }

        if (formValues.estado) {
            fetchMunicipios(formValues.estado);
        } else {
            setMunicipios([]);
        }

    }, [formValues.estado])

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'valorAluguel') {
            const moneyValue = value.replace(/\D/g, '');
            const formattedValue = (Number(moneyValue) / 100).toFixed(2);
            setFormValues({
                ...formValues,
                [name]: formattedValue
            });
            return;
        }

        setFormValues({
            ...formValues,
            [name]: value.toUpperCase()
        });
    }

    const handleSubmit = async (e) => {

        e.preventDefault();
        setLoading(true);

        const url = id ? `https://sistemaintegrado.palmont.com.br/Painel/API/Republicas/EditRep/index.php?id=${id}` : 'https://sistemaintegrado.palmont.com.br/Painel/API/Republicas/SaveRep/';

        try {

            await axios.post(url, formValues, { withCredentials: true });
            await fetchSuccess?.();
            closeModal();

        } catch (e) {

            let errorMessage = id ? "Ococrreu um erro ao atualizar a república." : "Ocorreu um erro ao adicionar uma nova república."
            notifyError(e.response?.data?.message || errorMessage);
            console.error(e)

        } finally {
            setLoading(false);
        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header={true} close={closeModal} >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="SITUAÇÃO"
                            type="select"
                            options={[
                                { label: 'ATIVO', value: 1 },
                                { label: 'INATIVO', value: 0 }
                            ]}
                            obj={true}
                            valor={formValues.situacao}
                            changeFunc={handleChange}
                            name="situacao"
                            required={true}
                        />
                        <FormComp
                            title="LOGRADOURO"
                            type="text"
                            placeholder="EX: AVENIDA, RUA, TRAVESSA, PRAÇA"
                            valor={formValues.logradouro}
                            changeFunc={handleChange}
                            name="logradouro"
                            required={true}
                        />
                        <FormComp
                            title="NÚMERO"
                            type="text"
                            placeholder="EX: 10"
                            valor={formValues.numero}
                            changeFunc={handleChange}
                            name="numero"
                            required={true}
                        />
                        <FormComp
                            title="COMPLEMENTO"
                            type="text"
                            placeholder="EX: PORTÃO VERDE, CASA 2"
                            valor={formValues.complemento}
                            changeFunc={handleChange}
                            name="complemento"
                        />
                        <FormComp
                            title="BAIRRO"
                            type="text"
                            placeholder="DIGITE O BAIRRO..."
                            valor={formValues.bairro}
                            changeFunc={handleChange}
                            name="bairro"
                            required={true}
                        />
                        <FormComp
                            title="ESTADO"
                            type="select"
                            options={listaEstados}
                            valor={formValues.estado}
                            changeFunc={(e) => {
                                const value = e.target.value
                                setFormValues(prev => ({
                                    ...prev,
                                    estado: value,
                                    cidade: ''
                                }));
                            }}
                            required={true}
                        />
                        <FormComp
                            title="CIDADE"
                            type="select"
                            options={municipios}
                            valor={formValues.cidade}
                            changeFunc={handleChange}
                            name="cidade"
                            required={true}
                        />
                        <FormComp
                            title="CENTRO DE CUSTO"
                            type="select"
                            options={centrosCustoOptions}
                            valor={formValues.centroCusto}
                            changeFunc={handleChange}
                            name="centroCusto"
                            required={true}
                        />
                        <FormComp
                            title="REPÚBLICA"
                            type="text"
                            placeholder="EX: REPÚBLICA 01"
                            valor={formValues.republica}
                            changeFunc={handleChange}
                            name="republica"
                            required={true}
                        />
                        <FormComp
                            title="INÍCIO DO CONTRATO"
                            type="date"
                            valor={formValues.inicioContrato}
                            changeFunc={handleChange}
                            name="inicioContrato"
                        />
                        <FormComp
                            title="TERMINO DO CONTRATO"
                            type="date"
                            valor={formValues.fimContrato}
                            changeFunc={handleChange}
                            name="fimContrato"
                        />
                        <FormComp
                            title="VALOR DO ALUGUEL"
                            type="number"
                            placeholder="EX: 1500.00"
                            valor={formValues.valorAluguel}
                            changeFunc={handleChange}
                            name="valorAluguel"
                        />
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </Formulario>
                </Modal>
                {loading && (
                    <Overlay state={true} >
                        <Modal size="sm" >
                            <SmallLoading />
                        </Modal>
                    </Overlay>
                )}
            </Overlay>
        </>
    )
}

export default ModalRepEdit;